import { PropertyCore } from "../../../odata/odata.coreapi";

export class EditInspectionDutyGroup {
  imName: string;
  guideline: string;
  inspectionDuties: PropertyCore.InspectionDuty[] = [];
}
